import React from "react";
import Slider from "react-slick";
import "./App.css"; // shared default styles
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { NextArrow, PrevArrow } from "./CustomArrow";

const ReusableSlider = ({ data, className = "", settings = {} }) => {
    const defaultSettings = {
      dots: false,
      infinite: false,
      speed: 500,
      fade:true,
      slidesToShow: 1,
      slidesToScroll: 1,
      nextArrow: <NextArrow />,
      prevArrow: <PrevArrow />,
      responsive: [        
        {
          breakpoint: 576,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            fade: true,
            dots:true,
          },
        },
      ],
      ...settings,
    };
  
    return (
      <div className={`slider-wrapper ${className}`}>
        <Slider {...defaultSettings}>
          {data.map((content, index) => (
            <div key={index} className="slider-item">
              {content}
            </div>
          ))}
        </Slider>
      </div>
    );
  };
  
  export default ReusableSlider;